import { Context } from "@silvertours/front-shared";
var useSessionData = function() {
    var result = Context.useClientContext("sessionData");
    var securityTokenValue = result.hasContext ? result.value.securityTokenValue : "";
    var gtmEnvironment = result.hasContext ? result.value.gtmEnvironment : "live";
    var anonymizeIP = result.hasContext ? result.value.anonymizeIP : true;
    return {
        securityTokenValue: securityTokenValue,
        gtmEnvironment: gtmEnvironment,
        anonymizeIP: anonymizeIP
    };
};
export { useSessionData };
